export enum JobStatus {
    Created = 'created',
    InProgress = 'in_progress',
    Finished = 'finished',
    TimedOut = 'timed_out',
    Canceled = 'canceled',
}
